import { some } from "../common/constants";
import RGL from "react-grid-layout";

export interface IRouteObject {
  caseSensitive?: boolean;
  children?: IRouteObject[];
  element?: React.ReactNode;
  icon?: React.ReactNode;
  index?: boolean;
  hidden?: boolean;
  staticRoute?: boolean;
  fixedRoute?: boolean;
  path?: string;
  title?: string | React.ReactNode;
  listRole?: string[][];
}

export const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export const mappedRoutesPermissionLayout = (
  list: IRouteObject[],
  menus: some[],
  isAdmin?: boolean
): IRouteObject[] => {
  return list
    .map((one) => {
      if (one.staticRoute || one.index || one.fixedRoute) {
        return one;
      }

      if (one.path) {
        const tmp = menus.find((v) => v.url === one.path);
        if (!tmp && !isAdmin) {
          return undefined;
        }
        const children =
          one.children && (isAdmin ? true : tmp?.children)
            ? mappedRoutesPermissionLayout(
                one.children,
                tmp?.children || [],
                isAdmin
              )
            : [];
        return {
          ...one,
          children: children,
        };
      }

      return undefined;
    })
    .filter(Boolean) as IRouteObject[];
};

export const mappedRoutesPermission = (
  list: IRouteObject[],
  menus: some[],
  isAdmin?: boolean
): IRouteObject[] => {
  return list
    .map((one) => {
      if (one.staticRoute) {
        return undefined;
      }

      if (one.path === "*" || one.index || one.fixedRoute) {
        return one;
      }

      if (one.path) {
        const tmp = menus.find((v) => v.url === one.path);
        if (!tmp && !isAdmin) {
          return undefined;
        }
        const children =
          one.children &&
          one.children?.filter((child) => !child.staticRoute)?.length > 0 &&
          (isAdmin ? true : tmp?.children)
            ? mappedRoutesPermission(
                one.children.filter((child) => !child.staticRoute),
                tmp?.children || [],
                isAdmin
              )
            : undefined;
        return {
          ...one,
          children: children,
        };
      }

      return undefined;
    })
    .filter(Boolean) as IRouteObject[];
};

export const createGridLayout = (
  numRow: number,
  numCol: number,
  rowWidth: number,
  rowHeight: number
): RGL.Layout[] => {
  const result: RGL.Layout[] = [];

  for (var i = 0; i < numRow; i++) {
    for (var j = 0; j < numCol; j++) {
      result.push({
        w: rowWidth,
        h: rowHeight,
        i: `${i * numCol + j}`,
        x: j * rowWidth,
        y: i * rowHeight,
      });
    }
  }
  return result;
};

export const createLayoutByGridSize = (size: number): RGL.Layout[] => {
  if (size === 1) {
    return createGridLayout(1, 1, 12, 30);
  } else if (size === 2) {
    return createGridLayout(2, 2, 6, 16);
  } else if (size === 4) {
    return createGridLayout(4, 4, 3, 9);
  }
  return createGridLayout(3, 3, 4, 12);
};
